/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  error: '',
  dashboard_images_latest: [],
  dashboard_loglist_latest: [],

});

// State object
const state = initialState();
// Getter functions
const getters = {
  getError:(state) => state.error,
  getDashboardImagesLatest:(state) => state.dashboard_images_latest,
  getDashboardLoglistLatest:(state) => {
    let dashboard_loglist_latest_copy = JSON.parse(JSON.stringify(state.dashboard_loglist_latest));
    return dashboard_loglist_latest_copy.sort(function(a, b) {
      let date_a = new Date(a.updated);
      let date_b = new Date(b.updated);
      return date_b.getTime() - date_a.getTime();
    });
  },
  getDashboardLoglistBadgeCount:(state, getters, rootState) => {
    let date_lastlogin = new Date(rootState.Auth.current_user.updated);
    let count = 0;
    state.dashboard_loglist_latest.forEach((entry) => {
      let entry_date = new Date(entry.updated);
      if(entry_date.getTime() >= date_lastlogin.getTime()){
        count++;
      }
    });
    return count;
  },
  getDashboardImagesBadgeCount:(state, getters, rootState) => {
    let date_lastlogin = new Date(rootState.Auth.current_user.updated);
    let count = 0;
    state.dashboard_images_latest.forEach((entry) => {
      let entry_date = new Date(entry.updated);
      if(entry_date.getTime() >= date_lastlogin.getTime()){
        count++;
      }
    });
    return count;
  }
};
// Actions
const actions = {
  requestLatestLoglistEntities({ commit }) {
    axios({
      url: 'projects/0/latestlogentries',
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
    .then(resp => {
      commit('set_dashboard_loglist_latest', resp.data.data);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  requestLatestImageEntities({ commit }) {
    axios({
      url: 'projects/0/latestimages',
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
    .then(resp => {
      commit('set_dashboard_images_latest', resp.data.data);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },

};
// Mutations
const mutations = {
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_error(state, err){
    state.error = err;
  },
  set_dashboard_loglist_latest(state, loglist) {
    state.dashboard_loglist_latest = [...loglist];
  },
  set_dashboard_images_latest(state, images) {
    state.dashboard_images_latest = [...images];
  }


};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
